module.exports = __webpack_public_path__ + "static/media/key.5bd5fa97.png";